// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"25":"3ca3d318","255":"cc944079","299":"2da9e39a","623":"b4f0216e","726":"9ecb843d"}[chunkId] + ".chunk.css";
};